<div class="card mt-3">
  <div class="card-body">
    <h3 class="mb-4">{{ 'MENU.DASHBOARD.edit_countries' | translate }}</h3>

    <div *ngIf="isLoading" class="text-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <form #countryForm="ngForm" (ngSubmit)="onSubmit()" *ngIf="!isLoading">
      <div class="row">
        
        <!-- Country Name (English) -->
        <div class="col-sm-6">
          <div class="mb-3">
            <label class="form-label">
              {{ 'MENU.DASHBOARD.countries_name_en' | translate }}
              <span class="text-danger">*</span>
            </label>
            <input
              type="text"
              class="form-control"
              placeholder="{{ 'MENU.DASHBOARD.enter_countries_name_en' | translate }}"
              [(ngModel)]="countryFormData.name_en"
              name="name_en"
              required
              minlength="2"
              #nameEn="ngModel"
              (input)="onFieldInput('name_en', $event)"
            />
            <div *ngIf="nameEn.invalid && (nameEn.touched || countryForm.submitted)" class="text-danger small mt-1">
              <div *ngIf="nameEn.errors?.['required']">
                {{ 'MENU.DASHBOARD.countries_name_en_required' | translate }}
              </div>
              <div *ngIf="nameEn.errors?.['minlength']">
                {{ 'MENU.DASHBOARD.countries_name_min_length' | translate }}
              </div>
            </div>
          </div>
        </div>

        <!-- Country Name (Arabic) -->
        <div class="col-sm-6">
          <div class="mb-3">
            <label class="form-label">
              {{ 'MENU.DASHBOARD.countries_name_ar' | translate }}
              <span class="text-danger">*</span>
            </label>
            <input
              type="text"
              class="form-control"
              placeholder="{{ 'MENU.DASHBOARD.enter_countries_name_ar' | translate }}"
              [(ngModel)]="countryFormData.name_ar"
              name="name_ar"
              required
              minlength="2"
              #nameAr="ngModel"
              (input)="onFieldInput('name_ar', $event)"
            />
            <div *ngIf="nameAr.invalid && (nameAr.touched || countryForm.submitted)" class="text-danger small mt-1">
              <div *ngIf="nameAr.errors?.['required']">
                {{ 'MENU.DASHBOARD.countries_name_ar_required' | translate }}
              </div>
              <div *ngIf="nameAr.errors?.['minlength']">
                {{ 'MENU.DASHBOARD.countries_name_min_length' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Debug Info -->
      <!-- <div class="row mt-3">
        <div class="col-12">
          <div class="card bg-light">
            <div class="card-body">
              <h6>بيانات المراجعة:</h6>
              <p><strong>English:</strong> "{{ countryFormData.name_en }}"</p>
              <p><strong>Arabic:</strong> "{{ countryFormData.name_ar }}"</p>
              <p><strong>Form Valid:</strong> {{ countryForm.valid }}</p>
            </div>
          </div>
        </div>
      </div> -->

      <div class="text-start mt-4">
        <button
          type="submit"
          class="btn btn-suc px-4 mx-2"
          [disabled]="countryForm.invalid || isLoading"
        >
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
          {{ 'MENU.DASHBOARD.edit_countries' | translate }}
        </button>

        <button
          type="button"
          class="btn btn-secondary ms-2 px-4"
          (click)="cancel()"
          [disabled]="isLoading"
        >
          {{ 'MENU.DASHBOARD.cancel' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>